var _defs, _g, _g2, _g3, _path, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    zoomAndPan: "magnify",
    viewBox: "0 0 39 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ae4ac0f738"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.628906 0 L 38.371094 0 L 38.371094 29.03125 L 0.628906 29.03125 Z M 0.628906 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8fc51b2c31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 20 L 13 20 L 13 29.027344 L 4 29.027344 Z M 4 20 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e37044bd7e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.632812 4 L 23 4 L 23 26 L 0.632812 26 Z M 0.632812 4 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be4db73787"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16 3 L 38.371094 3 L 38.371094 25 L 16 25 Z M 16 3 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae4ac0f738)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.628906 0 L 38.371094 0 L 38.371094 36.289062 L 0.628906 36.289062 Z M 0.628906 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.628906 0 L 38.371094 0 L 38.371094 29.03125 L 0.628906 29.03125 Z M 0.628906 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.628906 0 L 38.371094 0 L 38.371094 29.03125 L 0.628906 29.03125 Z M 0.628906 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8fc51b2c31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004aad",
    d: "M 8.441406 20.3125 C 10.855469 20.3125 12.816406 22.261719 12.816406 24.667969 C 12.816406 27.070312 10.855469 29.019531 8.441406 29.019531 C 6.027344 29.019531 4.070312 27.070312 4.070312 24.667969 C 4.070312 22.261719 6.027344 20.3125 8.441406 20.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e37044bd7e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004aad",
    d: "M 19.988281 11.796875 L 19.988281 22.046875 L 4.878906 13.359375 L 15.128906 7.46875 C 15.230469 7.410156 15.296875 7.296875 15.296875 7.179688 L 15.296875 4.703125 C 15.296875 4.445312 15.015625 4.28125 14.789062 4.410156 L 1.339844 12.140625 C 0.902344 12.394531 0.632812 12.859375 0.632812 13.359375 C 0.632812 13.863281 0.902344 14.328125 1.339844 14.582031 L 20.695312 25.707031 C 20.914062 25.832031 21.160156 25.894531 21.40625 25.894531 C 21.648438 25.894531 21.894531 25.832031 22.113281 25.707031 C 22.550781 25.453125 22.820312 24.988281 22.820312 24.484375 L 22.820312 13.039062 C 22.820312 12.921875 22.753906 12.808594 22.652344 12.75 L 20.496094 11.507812 C 20.273438 11.375 19.988281 11.539062 19.988281 11.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M 30.5625 8.707031 C 28.148438 8.707031 26.191406 6.757812 26.191406 4.355469 C 26.191406 1.953125 28.148438 0.00390625 30.5625 0.00390625 C 32.980469 0.00390625 34.9375 1.953125 34.9375 4.355469 C 34.9375 6.757812 32.980469 8.707031 30.5625 8.707031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be4db73787)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M 19.015625 17.226562 L 19.015625 6.976562 L 34.128906 15.660156 L 23.878906 21.550781 C 23.773438 21.613281 23.710938 21.722656 23.710938 21.84375 L 23.710938 24.320312 C 23.710938 24.578125 23.992188 24.738281 24.214844 24.609375 L 37.664062 16.882812 C 38.101562 16.628906 38.375 16.164062 38.375 15.660156 C 38.375 15.15625 38.101562 14.691406 37.664062 14.441406 L 18.308594 3.316406 C 18.089844 3.191406 17.847656 3.128906 17.601562 3.128906 C 17.355469 3.128906 17.113281 3.191406 16.894531 3.316406 C 16.457031 3.566406 16.1875 4.03125 16.1875 4.535156 L 16.1875 15.980469 C 16.1875 16.101562 16.25 16.210938 16.355469 16.273438 L 18.507812 17.515625 C 18.734375 17.644531 19.015625 17.484375 19.015625 17.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b32d6a296dccfd05aa3d5e0d683505e3.svg";
export { ForwardRef as ReactComponent };